import React, { Component } from "react";
import * as Sentry from "@sentry/react";
import HotelRating from "../HotelRating";

class ResultPhotosResult extends Component {
  hotelName() {
    const { id, hasHWord, name } = this.props.result.hotel;

    if (hasHWord) {
      return <strong itemProp="name">{name}</strong>;
    }

    return (
      <>
        Hôtel <strong itemProp="name">{name}</strong>
      </>
    );
  }

  coverPicture() {
    const { hotel } = this.props.result;
    const { cover_picture: picture } = hotel;

    if (picture) {
      return (
        <img
          src={picture.url}
          alt={picture.legend || `Photo de ${hotel.name}`}
          itemProp="photo"
          loading="lazy"
        />
      );
    }

    return null;
  }

  editorPick() {
    if (this.props.result.hotel.preferred) {
      return (
        <span className="editor-pick">
          <span
            className="badge"
            data-icon="&#xe601;"
            aria-hidden
            title="Sélection Hôtel à Paris"
          />
        </span>
      );
    }

    return null;
  }

  price() {
    const {
      result: { offer },
      searchAttributes,
    } = this.props;

    if (!offer.price_value) {
      return "Prix non communiqué";
    }

    return (
      <div>
        <strong>{offer.price_formatted}</strong>
        <span className="link-more">Voir les offres</span>
        {searchAttributes && searchAttributes.nights > 1 ? " /nuit" : null}
      </div>
    );
  }

  quarter() {
    const { quarter } = this.props.result.hotel;

    if (quarter) {
      return (
        <small
          itemProp="location"
          itemScope
          itemType="https://schema.org/Place"
        >
          <a href={quarter.url} rel="external" itemProp="url">
            <span itemProp="name">{quarter.name}</span>
          </a>
        </small>
      );
    }

    return null;
  }

  render() {
    const { hotel } = this.props.result;

    const captionKlasses = ["caption"];
    if (hotel.preferred) {
      captionKlasses.push("with-editor-pick");
    }

    return (
      <li itemScope itemType="https://schema.org/Hotel">
        <Sentry.ErrorBoundary
          beforeCapture={(scope) => {
            scope.setContext("hotel-result", this.props.result);
          }}
        >
          <div className="cover-picture">{this.coverPicture()}</div>
          <div className={captionKlasses.join(" ")}>
            <p className="hotel-name">
              <a href={hotel.url} rel="external" itemProp="url">
                {this.hotelName()}
              </a>
              {this.editorPick()}
            </p>{" "}
            <p>
              <HotelRating
                rating={hotel.rating}
                ratingText={hotel.ratingText}
              />{" "}
              {this.quarter()}
            </p>
          </div>

          <div className="our-price">
            <a href={hotel.url} rel="external">
              {this.price()}
            </a>
          </div>
        </Sentry.ErrorBoundary>
      </li>
    );
  }
}

export default ResultPhotosResult;
